const SAFE_PROTOCOLS = new Set(["http:", "https:"]);
export const assertSafeReturnUrl = (returnUrl, baseUrl) => {
    const raw = returnUrl || baseUrl;
    let parsed;
    let base;
    try {
        parsed = new URL(raw, baseUrl);
        base = new URL(baseUrl);
    }
    catch (_a) {
        throw new Error("Unable to parse returnUrl");
    }
    if (!SAFE_PROTOCOLS.has(parsed.protocol)) {
        throw new Error("Unsupported returnUrl protocol");
    }
    if (parsed.username || parsed.password) {
        throw new Error("Return URL must not contain credentials");
    }
    if (!isAllowedReturnHost(parsed.hostname, base.hostname)) {
        throw new Error("Return URL host is not allowed");
    }
    return parsed.href;
};
export const isAllowedReturnHost = (hostname, currentHostname) => {
    const normalized = hostname.toLowerCase();
    const current = currentHostname === null || currentHostname === void 0 ? void 0 : currentHostname.toLowerCase();
    return (normalized === "metal.com" ||
        normalized.endsWith(".metal.com") ||
        normalized === "localhost" ||
        normalized === "127.0.0.1" ||
        (!!current && normalized === current));
};
export const buildLoginRedirectUrl = (userCenterUrl, locale, action, returnUrl) => {
    const url = new URL(`/${locale}/login`, userCenterUrl);
    url.searchParams.set("action", action);
    url.searchParams.set("url", returnUrl);
    return url.href;
};
//# sourceMappingURL=return-url.js.map